<script>
  import { encodeAlphanet, decodeAlphanet } from "tezos-uri";

  import Box from "./Box.svelte";
  import ExampleBox from "./ExampleBox.svelte";
  import EncodeBox from "./EncodeBox.svelte";

  let exampleToEncode = prettyPrint(
    `[{"content":{"kind":"transaction","amount":"100000","destination":"tz1NAP47ubff4JDLJ94UcwEs66dDDAJGRDwN"}}]`
  );
  let exampleEncoded = encodeWrapper(exampleToEncode);
  let exampleToDecode = `web+tezosalphanet:4thVcmfFUC7bLTkuHjMZ9PvdcZgUx9AZ9b6hDa1TbafzNjE8sQ8KMuKEqfjqkVuMNUi26VT4WdCSRX6MR55ANCMBzDRuQoz1JFtA6Cyu2qWW2JLXR84XBygS4p8b3PsJjo7beSj3QNB1jUUikjDnotXs`;
  let exampleDecoded = prettyPrint(decodeWrapper(exampleToDecode));

  let toEncode = "";
  let toDecode = "";
  $: encoded = encodeWrapper(toEncode);
  $: decoded = decodeWrapper(toDecode);
  $: decodedPretty = prettyPrint(decoded);

  function encodeWrapper(payload) {
    try {
      return encodeAlphanet(JSON.parse(payload));
    } catch (e) {
      return e.toString();
    }
  }
  function decodeWrapper(request) {
    try {
      return JSON.stringify(decodeAlphanet(request));
    } catch (e) {
      return e.toString();
    }
  }
  function prettyPrint(j) {
    try {
      return JSON.stringify(JSON.parse(j), null, 2);
    } catch (_) {
      return j;
    }
  }
  function handleToEncode() {
    toEncode = prettyPrint(toEncode);
  }
</script>

<style>
  div#main {
    margin: 8px;
    width: 100%;
    background-color: #31466a;
    color: white;
  }

  h1 {
    font-weight: 300;
    font-size: 2.5rem;
  }

  #header > h1 > div {
    font-size: 1.6rem;
    margin-top: 0px;
    margin-left: 250px;
    width: fit-content;
  }
  a {
    text-decoration-line: underline;
    color: white;
  }
  div#content-grid > p {
    grid-area: p;
  }
  p {
    font-size: 1.2rem;
    margin: 12px;
  }

  div#boxes {
    grid-area: b;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;
    margin: 4px 10px;
  }

  div#header {
    grid-area: x;
    margin: auto;
  }

  @media (min-width: 992px) {
    div#content-grid {
      display: grid;
      grid-template:
        ". x ."
        ". p ."
        ". b .";
      grid-template-rows: auto auto auto;
      grid-template-columns: 1fr auto 1fr;
      grid-gap: 4px;
    }

    div#boxes {
      max-width: 992px;
    }
    div#content-grid > p {
      max-width: 992px;
    }
  }

  @media (max-width: 992px) {
    div#content-grid {
      display: grid;
      grid-template:
        "x"
        "p"
        "b";
      grid-template-rows: auto auto auto;
      grid-template-columns: auto;
      grid-gap: 4px;
    }

    h1 {
      font-size: 40px;
    }

    #header {
      margin: auto;
      text-align: center;
      width: fit-content;
      width: -moz-fit-content;
    }

    #header > h1 > div {
      font-size: 20px;
      margin-top: 0px;
      margin-left: auto;
      margin-right: 0px;
    }

    p {
      font-size: 18px;
    }
  }
</style>

<div id="main">
  <div id="content-grid">
    <div id="header">
      <h1>
        SCL Tezos URI Tool
        <div>
          by
          <a href="https://smartcontractlabs.ee">Smart Contract Labs</a>
        </div>
      </h1>
    </div>
    <p>
      Welcome! You can use this tool to encode and decode requests. Just paste
      the JSON or URI into the boxes. Or you can write the objects by hand and
      look at validator feedback. More details
      <a href="https://gitlab.com/smartcontractlabs/tezos-uri">here</a>.
    </p>

    <div id="boxes">
      <EncodeBox
        label={'Payload To Encode'}
        bind:content={toEncode}
        on:click={handleToEncode} />
      <ExampleBox label={'Encoded'} bind:content={encoded} />
      <ExampleBox label={'Example Payload'} bind:content={exampleToEncode} />
      <ExampleBox
        label={'Example Encoded Request'}
        bind:content={exampleEncoded} />
      <Box label={'Request To Decode'} bind:content={toDecode} />
      <ExampleBox label={'Decoded'} bind:content={decodedPretty} />
      <ExampleBox label={'Example Request'} bind:content={exampleToDecode} />
      <ExampleBox
        label={'Example Decoded Payload'}
        bind:content={exampleDecoded} />
    </div>

  </div>
</div>
